import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const emmdepartmentApi = api
  .enhanceEndpoints({ addTagTypes: ['Department'] })
  .injectEndpoints({
    endpoints: builder => ({
      getDepartments: builder.query<em_mdepartment[], string>({
        query: cid => `emdepartment/${cid}`,
        providesTags: ['Department']
      }),
      getDepartment: builder.query<em_mdepartment, string>({
        query: id => `emdepartment/byid/${id}`
      }),
      insertDepartment: builder.mutation({
        query: emdepartment => ({
          url: `emdepartment/`,
          method: 'POST',
          body: emdepartment
        }),
        invalidatesTags: ['Department']
      }),
      updateDepartment: builder.mutation({
        query: emdepartment => ({
          url: `emdepartment/`,
          method: 'PUT',
          body: emdepartment
        }),
        invalidatesTags: ['Department']
      }),
      deleteDepartment: builder.mutation({
        query: emdepartment => ({
          url: `emdepartment/${emdepartment.dp_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Department']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetDepartmentsQuery,
  useGetDepartmentQuery,
  useInsertDepartmentMutation,
  useUpdateDepartmentMutation,
  useDeleteDepartmentMutation
} = emmdepartmentApi;

